import editDialogReducer from './editDialogReducer';

export default editDialogReducer;